var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "perfil_-_sistema_-_arquitetos_-_celular",
    "data-name": "perfil - sistema - arquitetos - celular",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.766,
    height: 29.447,
    viewBox: "0 0 25.766 29.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1025",
    "data-name": "Caminho 1025",
    d: "M12.883,14.724A7.362,7.362,0,1,0,5.521,7.362,7.361,7.361,0,0,0,12.883,14.724Zm-2.628,2.761A10.253,10.253,0,0,0,0,27.739a1.708,1.708,0,0,0,1.708,1.708h22.35a1.708,1.708,0,0,0,1.708-1.708A10.253,10.253,0,0,0,15.512,17.484Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.eb1620e5fd9b8715553d1161898d7116.svg";
export { ForwardRef as ReactComponent };